import { FC, useState } from 'react'
import GoBackHeader from 'components/organisms/GoBackHeader'
import { useMutation } from '@apollo/client'
import { useHistory } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'hooks/store'
import {
  UPDATE_QUESTIONNAIRE_SHOWN_INSTRUCTIONS_FLAG,
  UpdateQuestionnaireShownInstructionsFlagVariables,
  UpdateQuestionnaireShownInstructionsFlagResponse
} from 'share/mutations/cases'
import { setQuestionnaireShownInstructionsFlag } from 'reducers/activecase/activecaseSlice'
import Button from 'react-bootstrap/Button'
import QuestionnaireInstructionsModal from 'components/features/dashboard/questionnaire/QuestionnaireInstructionsModal'
import { QUESIONNAIRE_INTRODUCTION_TEXT } from '../constants'
import {
  QuestionnaireIntroductionContainer,
  QuestionnaireIntroductionPage
} from './styles'
import { TwoBtnsOrderedContainer } from 'components/atoms/Layout'

const QuestionnaireIntroduction: FC = () => {
  const activeCase = useAppSelector((state) => state.activeCase)
  const dispatch = useAppDispatch()
  const [showCourseInstructionsModal, setShowCourseInstructionsModal] =
    useState(false)
  const history = useHistory()
  const [updateShownInstructionsFlag] = useMutation<
    UpdateQuestionnaireShownInstructionsFlagResponse,
    UpdateQuestionnaireShownInstructionsFlagVariables
  >(UPDATE_QUESTIONNAIRE_SHOWN_INSTRUCTIONS_FLAG)

  function getCaseId() {
    return activeCase.matter && activeCase.matter.id ? activeCase?.matter.id : 0
  }

  async function updateShownInstructionsFlagHelper(): Promise<boolean> {
    let result = false
    try {
      const input = {
        flag: true,
        caseId:
          activeCase.matter && activeCase.matter.id ? activeCase?.matter.id : 0
      }

      const updateResult = await updateShownInstructionsFlag({
        variables: { request: input }
      })
      if (
        updateResult.data?.cases.updateQuestionnaireShownInstructionsFlag
          .success
      ) {
        result = true
        if (activeCase) {
          if (activeCase.matter) {
            dispatch(setQuestionnaireShownInstructionsFlag(true))
          }
        }
      }
    } catch (e) {
      result = false
    }

    return result
  }

  async function continueClick() {
    await updateShownInstructionsFlagHelper()
    history.push('/dashboard/questionnaires/terms')
  }

  function viewInstructionsClicked() {
    setShowCourseInstructionsModal(true)
  }

  function closeViewInstructionsModal() {
    setShowCourseInstructionsModal(false)
  }

  function goBackHeaderOnClick() {
    history.push('/dashboard/case')
  }

  return (
    <>
      <GoBackHeader
        text='Bankruptcy Questionnaire'
        onClick={goBackHeaderOnClick}
      />
      <QuestionnaireIntroductionPage data-testid='questionnaire-introduction-page'>
        <h2>Let's get some info together for your case.</h2>
        <QuestionnaireIntroductionContainer data-testid='questionnaire-introduction-text'>
          {QUESIONNAIRE_INTRODUCTION_TEXT}
        </QuestionnaireIntroductionContainer>
        <TwoBtnsOrderedContainer>
          <Button
            onClick={continueClick}
            data-testid='questionnaire-introduction-continue-button'
          >
            Continue
          </Button>
          <Button
            variant='outline-secondary'
            onClick={viewInstructionsClicked}
            data-testid='questionnaire-introduction-view-instructions-button'
          >
            <span className='mdi mdi-information-outline mr-2' />
            Questionnaire Instructions
          </Button>
        </TwoBtnsOrderedContainer>
      </QuestionnaireIntroductionPage>
      <QuestionnaireInstructionsModal
        show={showCourseInstructionsModal}
        caseId={getCaseId()}
        onHide={closeViewInstructionsModal}
      />
    </>
  )
}

export default QuestionnaireIntroduction
